// many tools
// similar to mtsv. lay out tools
// props: tool references for each tool

import { observer } from 'mobx-react';
import React, { Fragment } from 'react';
import { DrawingToolsetViewModel } from '../viewModel/DrawingToolsetViewModel';
import { DrawingToolView } from './DrawingToolView';

import './toolsetStyle.scss';

interface IDrawingToolsetViewProps {
  drawingTools: DrawingToolsetViewModel;
}

export const DrawingToolsetView = observer((props: IDrawingToolsetViewProps) => {
  return (
    <Fragment>
      <div className="widget-button-set">
        <DrawingToolView tool={props.drawingTools.pointTool} title={'Draw Point'} icon={'esri-icon-map-pin'} />
        <DrawingToolView tool={props.drawingTools.polylineTool} title={'Draw Polyline'} icon={'esri-icon-polyline'} />
        <DrawingToolView tool={props.drawingTools.polygonTool} title={'Draw Polygon'} icon={'esri-icon-polygon'} />
        <DrawingToolView
          tool={props.drawingTools.rectangleTool}
          title={'Draw Rectangle'}
          icon={'esri-icon-checkbox-unchecked'}
        />
        <DrawingToolView
          tool={props.drawingTools.circleTool}
          title={'Draw Circle'}
          icon={'esri-icon-radio-unchecked'}
        />
        <DrawingToolView
          tool={props.drawingTools.textTool}
          title={'Draw Text'}
          icon={'esri-icon-comment'}
          textInputProps={props.drawingTools.textDrawingProps}
        />
        <DrawingToolView tool={props.drawingTools.deleteTool} title={'Delete Drawing'} icon={'esri-icon-erase'} />
      </div>
    </Fragment>
  );
});
